import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Paper, Button, Input } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  search: {
    flexGrow: 1,
    height: 52,
    padding: theme.spacing(0, 2),
    display: 'flex',
    alignItems: 'center',
  },
  disabledSearch: {
    backgroundColor: '#e6e6e6',
    cursor: 'not-allowed',
  },
  searchIcon: {
    marginRight: theme.spacing(2),
    color: theme.palette.icon,
  },
  searchInput: {
    // flexGrow: 1,
  },
  searchButton: {
    marginLeft: theme.spacing(2),
    height: '52px',
  },
}));

function Search({
  onSearch,
  className,
  placeholder,
  buttontext,
  onChange,
  hidebutton,
  resetInput,
  disabled,
  height,
  padding,
  btnDisabled,
  searchInputStyle,
  inputType,
  ...rest
}) {
  const classes = useStyles();
  const searchInput = useRef('');

  const handleNumberInput = (e, value) => {
    const regex = /^\d*$/;
    if (value && regex.test(value)) {
      onChange(e, value);
    } else {
      searchInput.current.value = '';
    }
  };
  useEffect(() => {
    if (resetInput) {
      searchInput.current.value = '';
      onChange({}, '');
    }
    // eslint-disable-next-line
  }, [resetInput]);

  return (
    <div
      {...rest}
      className={clsx(classes.root, className, `${disabled ? classes.disabledSearch : ''}`)}
    >
      <Paper
        className={`${classes.search} ${disabled ? classes.disabledSearch : ''}`}
        style={{ height, padding }}
        elevation={0}
      >
        <SearchIcon className={classes.searchIcon} />
        <Input
          inputProps={inputType === 'number' ? { maxlength: '10' } : {}}
          className={`${classes.searchInput} ${disabled ? classes.disabledSearch : ''}`}
          disableUnderline
          placeholder={placeholder || 'Search...'}
          inputRef={searchInput}
          fullWidth
          onChange={event =>
            inputType === 'number'
              ? handleNumberInput(event, searchInput.current.value)
              : onChange
              ? onChange(event, searchInput.current.value)
              : onChange
          }
          disabled={disabled}
          style={searchInputStyle}
        />
      </Paper>
      {hidebutton && hidebutton.toString() === 'true' ? null : (
        <Button
          className={classes.searchButton}
          onClick={event => (onSearch ? onSearch(event, searchInput.current.value) : onSearch)}
          size="large"
          variant="contained"
          color="primary"
          disabled={btnDisabled}
        >
          {buttontext || 'Search'}
        </Button>
      )}
    </div>
  );
}

Search.propTypes = {
  className: PropTypes.string,
  onSearch: PropTypes.func,
};

export default Search;
